import { z } from "zod";
import { apiListSchema } from "./list";

//? DTO
const CreateReservationDayDtoSchema = z.object({
  ReservationId: z.number(),
  Day: z.number().nullish(),
  Name: z.string().nullish(),
});
export type CreateReservationDayDto = z.infer<
  typeof CreateReservationDayDtoSchema
>;

export const ReservationDayDtoSchema = CreateReservationDayDtoSchema.extend({
  Id: z.number(),
});
export type ReservationDayDto = z.infer<typeof ReservationDayDtoSchema>;

export const reservationDayDtoListSchema = apiListSchema(
  ReservationDayDtoSchema,
);

//? Model

export const CreateReservationDaySchema = z.object({
  reservationId: z.number(),
  day: z.number(),
  name: z.string().nullish(),
});

export const ReservationDaySchema = CreateReservationDaySchema.extend({
  id: z.string().min(1),
});

export type CreateReservationDay = z.infer<typeof CreateReservationDaySchema>;

export type ReservationDay = z.infer<typeof ReservationDaySchema>;

//? Mappers

export function reservationDayFromDto(dto: ReservationDayDto): ReservationDay {
  return {
    id: dto.Id.toString(),
    day: dto.Day ?? -1,
    name: dto.Name,
    reservationId: dto.ReservationId,
  };
}

export function reservationDayToDto(dto: ReservationDay): ReservationDayDto {
  return {
    Id: Number.parseInt(dto.id),
    ...createReservationDayToDto(dto),
  };
}

export function createReservationDayToDto(
  dto: CreateReservationDay,
): CreateReservationDayDto {
  return {
    Day: dto.day,
    Name: dto.name,
    ReservationId: dto.reservationId,
  };
}
